const initialState = {
    jobId: null,
    auditorName: null,
    locationName: null,
    signedOffBy: null,
    signOffDateTime: null,
    orders: [],
};

const tyreCheckReducer = (state = initialState, action) => {
    if (action.type === "SET_TYRE_CHECK") {
        return {
            ...state,
            ...action.payload
        };
    }
    return state;
};

export default tyreCheckReducer;
